module.exports = __webpack_public_path__ + "assets/images/BSD100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BSD100.png
// module id = 1316
// module chunks = 1